import styled from "styled-components";
import Overlay from "../../../Componentes/Overlay";
import Modal from "../../../Componentes/Utils/Modal";
import useApi from "../../../hooks/useApi";
import { useState } from "react";

const Titulo = styled.h2`
    margin: 0 0 15px 0;
    font-size: 18px;
    color: #333;
    text-align: center;
`
const Subtitulo = styled.p`
    margin: 0;
    font-size: 14px;
    color: #555;
    text-align: center;
`
const DescricaoGrupo = styled.p`
    margin: 10px 0 0 0;
    font-size: 13px;
    color: #111;
    text-align: center;
    font-weight: bold;
`
const ErrorMsg = styled.p`
    margin: 15px 0 0 0;
    font-size: 13px;
    color: #b91c1c;
    text-align: center;
`
const BotoesWrapper = styled.div`
    margin-top: 35px;
    display: flex;
    justify-content: flex-end;
    gap: 10px;
`
const Botao = styled.button`
    padding: 9px 12px;
    background-color: ${props => props.cancel ? '#e5e7eb' : '#e11d48'};
    color: ${props => props.cancel ? '#333' : 'white'};
    border: none;
    border-radius: 5px;
    cursor: pointer;
    transition: .2s all ease;
    &:disabled {
        background-color: ${props => props.cancel ? '#e5e7eb' : '#fda4af'};
        cursor: auto;
    }
    &:hover:not(:disabled) {
        background-color: ${props => props.cancel ? '#d1d5db' : '#be123c'};
    }
`

const ConfirmDeleteGrupo = ({ grupo, fecharModal, onDelete }) => {

    const api = useApi();

    const [saving, setSaving] = useState(false);
    const [erro, setErro] = useState(null);

    const handleDelete = async () => {

        if (!grupo?.id) return;

        setSaving(true);
        setErro(null);

        try {

            await api.post(`/Painel/API/ControleMedicao/DeleteGrupo/index.php?id=${grupo.id}`);

            if (onDelete) onDelete();
            fecharModal();

        } catch (error) {

            console.error("Erro ao excluir grupo:", error);
            const msg = error?.response?.data?.message || "Erro ao excluir grupo.";
            setErro(msg);

        } finally {

            setSaving(false);

        }

    }

    return (
        <Overlay state={true}>
            <Modal size="sm">
                <Titulo>Confirmar exclusão</Titulo>
                <Subtitulo>Tem certeza que deseja excluir este grupo?</Subtitulo>
                {
                    grupo && (
                        <DescricaoGrupo>
                            {grupo.number} - {grupo.descricao}
                        </DescricaoGrupo>
                    )
                }
                {erro && <ErrorMsg>{erro}</ErrorMsg>}
                <BotoesWrapper>
                    <Botao cancel type="button" onClick={fecharModal} disabled={saving}>CANCELAR</Botao>
                    <Botao type="button" onClick={handleDelete} disabled={saving}>EXCLUIR</Botao>
                </BotoesWrapper>
            </Modal>
        </Overlay>
    );

}

export default ConfirmDeleteGrupo;
